export const POST_CONVERSIONS_SUCCESS = 'POST_CONVERSIONS_SUCCESS';
export const POST_CONVERSIONS_FAIL = 'POST_CONVERSIONS_FAIL';

export const GET_CONVERSIONS_SUCCESS = 'GET_CONVERSIONS_SUCCESS';
export const GET_CONVERSIONS_FAIL = 'GET_CONVERSIONS_FAIL'

export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAIL = 'GET_GROUPS_FAIL';

export const GET_USER_COMPANY_DATA_SUCCESS = 'GET_USER_COMPANY_DATA_SUCCESS'
export const GET_USER_COMPANY_DATA_FAIL = 'GET_USER_COMPANY_DATA_FAIL'

export const UPLOAD_CSV_DOCUMENT_SUCCESS = 'UPLOAD_CSV_DOCUMENT_SUCCESS'
export const UPLOAD_CSV_DOCUMENT_FAIL = 'UPLOAD_CSV_DOCUMENT_FAIL'